module.exports = __webpack_public_path__ + "img/oya_arima.731f981c.jpg";